import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import socketio from 'socket.io-client';
import Echo from 'laravel-echo';
import productActions from '../store/actions/productActions';

export const SOCKET_PRODUCT_BID = 'bid';

const usePublicSocket = (channelType) => {
    const [result, setResult] = useState(null);
    const {currentProduct} = useSelector((state) => state.products);
    const dispatch = useDispatch();

    useEffect(() => {
        if (window && !window.echo2) {
            const host = process.env.SOCKET_GATE;
            const path = `${process.env.PATH_PREFIX || ''}/socket.io`;
            if (!window.io) window.io = socketio;
            window.echo2 = new Echo({
                host,
                path,
                broadcaster: 'socket.io',
            });
        }

        if (window && window.echo2 && currentProduct?.link && channelType) {
            switch (channelType) {
                case SOCKET_PRODUCT_BID:
                    window.echo2.channel(`product_link.${currentProduct?.link}`)
                        .listen('.product.bid.new', (e) => {
                            setResult(e);
                            dispatch(productActions.getCurrentProductBid(e));
                        });
                    break;
                default:
                    break;
            }
        }

        return () => {
            if (window && window.echo2 && currentProduct?.link && channelType) {
                switch (channelType) {
                    case SOCKET_PRODUCT_BID:
                        window.echo2.leave(`product_link.${currentProduct?.link}`);
                        break;
                    default:
                        break;
                }
            }
        };
    }, [currentProduct]);

    return result;
};

export default usePublicSocket;
